import React, { useState, useContext } from 'react'
import { Card, Modal, Button } from 'antd'
import PropTypes from 'prop-types'
import { ProductListContext } from '../../contexts'
import { getDescription } from '../../utils/product-descriptions'

const { Meta } = Card

function CoverImage({ name, title, image, onOrderClick }) {
  const [showDescription, setShowDescription] = useState(false)

  if (!image) {
    return null
  }

  const description = getDescription(name)

  const onReadMoreClick = () => {
    setShowDescription(true)
  }

  return (
    <>
      <img alt={name} src={image}/>
      <nav className="card-cover-actions">
        <Button type="secondary" onClick={onReadMoreClick}>Read More</Button>
        <Button type="primary" onClick={onOrderClick}>Order</Button>
      </nav>

      <Modal
        footer={null}
        centered={true}
        visible={showDescription}
        onCancel={() => setShowDescription(false)}
        destroyOnClose={true}
      >
        <h2>{title}</h2>
        <div className="contents" dangerouslySetInnerHTML={{ __html: description }}/>
      </Modal>
    </>
  )
}

const ProductItem = ({ name, title, description, image }) => {
  const {
    setSelectedProduct,
    setFormModalVisible,
  } = useContext(ProductListContext)

  const _onSelectProduct = () => {
    setFormModalVisible(true)
    setSelectedProduct(name)
  }

  const cover = <CoverImage
    name={name}
    title={title}
    image={image}
    onOrderClick={_onSelectProduct}
  />

  return (
    <Card cover={cover}>
      <Meta title={title} description={description}/>
    </Card>
  )
}

CoverImage.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  onOrderClick: PropTypes.func,
}

ProductItem.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
}

export default ProductItem
